import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import ToggleButtonGroup from '../../OpmsForm/Fields/ToggleButtonGroup';
import {darken, makeStyles, Theme} from "@material-ui/core/styles";

interface IToggleButtonGroupWrapperProps extends FieldRenderProps<any, any> {
}


const useStyles = makeStyles<Theme>(theme => ({
    fullWidth: {
        width: '100%'
    }
}));


export const ToggleButtonGroupWrapper: React.FunctionComponent<IToggleButtonGroupWrapperProps> = (
    properties) => {
    const {
        input: { name, value, onChange, ...restInput },
        meta,
        label,
        formControlProps,
        onChangeable,
        ...rest
    } = properties;

    const showError = meta.touched && (meta.error || (meta.submitError && !meta.dirtySinceLastSubmit)) && !meta.submitting;

    const classes = useStyles();

    return (
        < FormControl { ...formControlProps}
    error ={ showError} className={classes.fullWidth}>

            < ToggleButtonGroup
                input={properties.input}
                meta={meta}
                {...rest}
                name={name}
                inputProps={restInput}
                value={value} />

            {
        showError &&
                < FormHelperText >{ meta.error || meta.submitError}</ FormHelperText >
            }
        </ FormControl >
    );
};